export { default } from '../Root'
export type { RootProps } from '../Root'
